// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3YFyX","requiredAsterisk":"Info_requiredAsterisk__KDJo4"};